/* Add calendarEventId, Save Preference record  Feb 19, 2022 */
/* Add comments June 5, 2022 */
/* Add event for Reminders and Notifications Apr 29,2023 */
/* comment out d_className  Oct 10th, 2023 */
/* Amend add if(rm.startDate/rm.endDate) to allow record without any date Oct 28, 2023 */
/* Add activity Cost Nov 4, 2023 */
/* fix Bug in taskRec.vue m_prntRecChange Nov 25, 2023 */
/* Amend endDate Nov 25, 2023 */
/*  Format Time  Dec 2, 2023 */
/* Add $ to  fn_checkNoChange Jan 13, 2023 */
/* Amend to replace p_isRequired with p_required Feb 1, 2025 */
/* Add readOnly, required columns Feb 1, 2025 */
/* Add required Indicator Feb 15, 2025 */
<template lang="pug">
	b-modal(id="bm-kt-task" ref="bm-kt-task" size="lg" header-bg-variant="light" centered no-fade hide-header-close
			no-close-on-backdrop no-close-on-esc @ok="m_saveTask" @cancel="m_close")
		template(slot="modal-header")
			div
				span {{(d_rowModal.id ? 'Edit' : 'Add')}}
				b-dropdown(v-if="p_paeChg" class="type-opts" variant="outline-secondary" :text="c_rec_Activity" )
					b-dd-item-btn(v-for="i in c_paeOpts" :key="i.key" @click="m_paeChg(i)") {{i.lbl}}
				span(v-else) {{c_rec_Activity}}
				span(v-if="c_hdrTitle") {{c_hdrTitle}}
			div
				b-dropdown(v-if="c_isCal && p_mode!='add'" 
					class="opt-reminder" right lazy no-caret variant="outline-secondary"
					v-b-tooltip.hover.auto.ds500="'Reminders for this Activity'" )
					template(v-slot:button-content)
						//- fa-icon(:icon="['far', 'bell']")
						fa-layers
							fa-icon(:icon="['far', 'bell']")
							fa-layers-text(class="kt-bbl" transform="up-15 right-15" :value="d_rmndOpt.length" v-if="d_rmndOpt.length")
					kt-remind-opt(:p_appEnt="c_appEnt" :p_recData="d_rowModal" :p_rmndOpt="d_rmndOpt")
		template(slot="modal-footer" slot-scope="{ ok, cancel, hide }")
			b-button(size="sm" variant="primary" @click="ok()" :disabled="d_loading||d_error") Save
			b-button(size="sm" variant="outline-secondary" @click="cancel()") Close
		//- Loading
		kt-spinner(v-if="d_loading" :p_txt="c_rec_Activity")
		//- Error
		div(v-else-if="d_error" class="error")
			p(class="text-danger") Something went wrong ☹
			p(class="my-1 text-grey5") {{d_error}}	
			p() Please try again or refresh your browser session.
		//- Task Form. Need to use rec-wrap to make KT-List & KT-Select work
		rec-wrap(p_mode="task" p_isModal=true v-show="!d_loading && !d_error" :p_requiredColumns="d_requiredColumns")
			template(v-slot:rec-wrap-task)
				div(class="mb-3" )
					//-Parent Record
					div(class="form-group fg-500" v-if="!c_isCal")
						label {{d_prntAppEnt.Name}}
						kt-select(:p_appEntKey="d_prntAppEnt.key" :key="d_prntAppEnt.key"
							:p_currentVal="d_rowModal.prntRec"
							:p_readOnly="d_rowModal.id != null|| c_isRecView"
							p_required=true
							@change="m_prntRecChange"
							)
		<b-tabs  pills small >
			b-tab(active id=descTab title-item-class="what")
				<template slot='title'>
					<fa-icon icon="tasks" />Activity
				</template>
				span <span style="color:#ff9333;">*</span>indicates field is required.
				div(class="custom-field")
					<h1><span>Description</span></h1>
					div(class="bm-kt-task-inline")
						div(class="form-group fg-500 blueText" v-show="m_show('taskName')")
							label(class="required-labe") Activity Name
							b-form-input(id="taskName" size="sm" v-model="d_rowModal.taskName" required :disabled="m_readOnly('taskName')")
							<span v-if="d_rowModal.id" :class="c_completionClass">{{c_completionStatus}}</span>
					div(class="mb-3" )
						div(class="form-group fg-500 blueText" v-show="m_show('taskDescription')")
							label(class="required-labe") Description
							b-form-input(id="taskDescription" size="sm" v-model="d_rowModal.taskDescription" required :disabled="m_readOnly('taskDescription')" )
					//-Details
					//div(class="form-group" v-show="m_show('taskDetails')")
						label Activity Details
						//b-form-textarea(size="sm" v-model="d_rowModal.taskDetails" rows=4 :disabled="m_readOnly('taskDetails')")
				div(class="custom-field")
					<h1><span>Attributes</span></h1>
					<b-container class="bv-example-row">
						<b-row class="noPadding h-25">
							<b-col :class="m_required('taskTypeId')?'required-label':'blueText'">Type</b-col>
							<b-col :class="m_required('priority')?'required-label':'blueText'">Priority</b-col>
							<b-col :class="m_required('taskStatusId')?'required-label':'blueText'">Status</b-col>
							<b-col :class="m_required('percentComplete')?'required-label':'blueText'">% Complete</b-col>
						</b-row>
						<b-row >
							<b-col>						
								b-form-select(id="taskTypeId" size="xs" plain v-model="d_rowModal.taskTypeId"  :disabled="m_readOnly('taskTypeId')"
									:options="d_ref.selOpt(d_ref.taskTypes, d_rowModal.taskTypeId)" value-field="id" text-field="name")
							</b-col>
							<b-col>
								b-form-select(id="priority" size="xs" plain v-model="d_rowModal.priority" class="priority" :class="'pr-'+(d_rowModal.priority||0)"
									:options="d_ref.taskPriorities" :disabled="m_readOnly('priority')")
							</b-col>
							<b-col>
								b-form-select(id="taskStatusId" size="xs" plain v-model="d_taskStatusId" :options="d_ref.taskStatuses" 
									value-field="id" text-field="name" @change="m_tsChg" :disabled="m_readOnly('taskStatusId')")
							</b-col>
							<b-col>
								b-form-input(id="percentComplete" size="xs" v-model="d_rowModal.percentComplete" type="number"  min="0" max="100" placeholder="0 - 100" :disabled="m_readOnly('percentComplete')")
							</b-col>
						</b-row>
					</b-container>
				div(class="custom-field")
					<h1><span>When</span></h1>
					<b-container class="bv-example-row">
						<b-row class="noPadding h-25 ">
							<b-col :class="m_required('startDate')?'required-label':'blueText'">Start Date</b-col>
							<b-col :class="m_required('endDate')?'required-label':'blueText'">End Date</b-col>
							<b-col :class="m_required('completionDate')?'required-label':'blueText'" cols=3>Date Completed</b-col>
						</b-row>
						<b-row >
							<b-col>	
								div(class="dateTime-parent")
									div(class="datePart")
										b-form-input(name="startDate" size="sm" v-model="d_rowModal.startDate" type="date" :state="c_validStartDate"  required :disabled="m_readOnly('startDate')" )
									div(class="timePart")
										b-input-group(class="mb-1 bg-info")
											b-form-input(size="sm" id="startTime" v-model="c_localeStartTime" readonly type="text" :title="c_startTimeToolTip" :disabled="m_readOnly('startTime')" )
											b-input-group-append()
												b-form-timepicker(v-model="d_rowModal.startTime" button-only right aria-controls="startTime" button-variant="primary")
							</b-col>
							<b-col >
								div(class="dateTime-parent")
									div(class="datePart")
										b-form-input(size="sm" v-model="d_rowModal.endDate" @change="m_validateEndDate($event)" type="date" :state="c_validEndDate" v-b-tooltip :title="c_startDateToolTip" required :disabled="m_readOnly('endDate')")
									div(class="timePart")
										b-input-group(class="mb-1")
											b-form-input(id="endTime" name="endTime" size="sm" v-model="c_localeEndTime" type="text" readonly @change="m_validateEndTime($event)" :state="c_validEndTime" :title="c_endTimeToolTip" dropright v-bind:hour24="true" required :disabled="m_readOnly('endTime')")
											b-input-group-append()
												b-form-timepicker(v-model="d_rowModal.endTime" button-only right aria-controls="endTime" dropleft required button-variant="primary")
							</b-col>
							<b-col cols=3>
								b-form-input(id="completionDate" size="sm" v-model="d_rowModal.completionDate" type="date" @change="d_ux.cmpldt=false" :disabled="m_readOnly('completionDate')")
							</b-col>
						</b-row>
					</b-container>
				div(class="bm-kt-task-inline")
					div(class="form-group")
						label(:class="m_required('activityCost')?'required-label':''") Activity Cost
						b-input-group(size="sm" prepend="$"  )
							b-form-input(id="activityCost" size="sm" v-model="d_rowModal.activityCost" :disabled="m_readOnly('activityCost')")
				div()
					<details>
						<summary class="comments"><span class="fa-layers fa-1x"><fa-icon icon="comments"/><span v-if="(d_taskComments||[]).length>0"  class="fa-layers-counter zoom"  style="background:green">{{(d_taskComments||[]).length}}</span></span> Comments</summary>
						div(class="form-group " )
							div(class="ktt-comment scrollBar")
								//- span(v-if="(d_taskComments||[]).length == 0" class="small text-grey5") No comment added
								b-button(class="btn-add btn-add-cl-item" variant="outline-primary" title="Add comment" v-b-tooltip:dragbox.hover.topleft.ds500="'Add'" @click="m_addComment")
									fa-icon(icon="plus")
								b-button(class="btn-remove btn-remove-cl-item" variant="none" v-b-tooltip:dragbox.hover.topleft.ds500="'Delete'" title="Remove comment" @click="m_removeComment")
									fa-icon(icon="trash-alt")
								perfect-scrollbar(style="margin-top: 5px; height: 20px; margin-bottom: 5px")
									div(v-for="(c, cix) in d_taskComments" :key="c.order" class="comment-item")
										<span style="float:left;" ><img class="small-round-profile" :src="c.image" />{{c.teamMemberName}}</span>
										<span style="float:right;">{{c.addedUTCString}}</span>
										//span>{{c.comments}}</span>
										//input(type="text" v-model="c.comment" placeholder="Enter new comment" title="Click to Edit new comment")
										b-form-textarea(id="comment1" size="sm" v-model="c.comment" max-rows=5 autofocus :plaintext="!c.new")
										<span v-if="!c.new"> <b-button @click="m_tumpsUpClick(cix)" class="tumpsBtn" :title="c_tumpsUsers">&#128077;2</b-button><b-button @click="m_tumpsDownClick(cix)" class="tumpsBtn">&#128078;</b-button></span>
										//input(type="text" v-model="c.comment" placeholder="Enter new comment" title="Click to Edit new comment")

					</details>
			b-tab(id=whoTab title-item-class="who")
				<template slot='title'>
					<fa-icon icon="user" />Assigned To
				</template>
				div(class="custom-field")
					<h1><span>Assignees</span></h1>
					div(class="form-group fg-500" v-show="m_show('taskLeadId')")
						<span :class="m_required('taskLeadId')?'required-label':'blueText'">Activity Lead</span>
						kt-select(p_appEntKey="team"
							:p_currentVal="d_rowModal.taskLead"
							:p_dfltOpts="p_prntRecInfo.Team"
							:p_dfltOptsLbl="'Team Members in the Current ' + d_prntAppEnt.Name"
							@change="m_tlChange"
							required
							:p_readOnly="m_readOnly('taskLeadId')"
							)
					//-Assignees
					div(class="form-group fg-500" v-show="m_show('taskAssignees')")
						<span :class="m_required('taskAssignees')?'required-label':'blueText'">Assignee(s)</span>
						kt-list(p_appEntKey="team"
							:p_currentVals="d_rowModal.taskAssignees"
							:p_enableAdd="true"
							:p_dfltOpts="p_prntRecInfo.Team"
							:p_dfltOptsLbl="'Team Members in the Current ' + d_prntAppEnt.Name"
							@change="m_taChange"
							:p_readOnly="m_readOnly('taskAssignees')"
							)
					//-External Contacts
					div(class="form-group fg-500" v-show="m_show('externalContacts')")
						<span :class="m_required('externalContacts')?'required-label':'blueText'">External Contact(s)</span>
						kt-list(p_appEntKey="extr"
							:p_currentVals="d_rowModal.externalContacts"
							:p_enableAdd="true"
							@change="m_ecChange"
							:p_readOnly="m_readOnly('externalContacts')"
							)
			b-tab(id=detailstab title-item-class="whatDetails")
				<template slot='title'>
					<fa-icon icon="tools" />Activity Details
				</template>
				span(:class="m_required('taskDetails')?'required-label':'blueText'") Details:
				<vue-editor v-model="d_rowModal.taskDetails" @ready="m_getQuill"  :disabled="m_readOnly('taskDetails')"></vue-editor>
				div()
					<details>
						<summary class="checklist"><span class="fa-layers fa-x"><fa-icon icon="tasks"/><span v-if="(d_rowModal.taskChecklist||[]).length>0" class="fa-layers-counter zoom" style="background:green">{{(d_rowModal.taskChecklist||[]).length}}</span></span> Checklist</summary>
						div(class="form-group" v-show="m_show('taskChecklist')")
							div(class="ktt-checklist") 
								draggable(v-show="(d_rowModal.taskChecklist||[]).length>0" :list="d_rowModal.taskChecklist" handle=".btn-reorder-cl-item" 
								swapThreshold=.1 animation=150  @end="m_reorderCLItem")
									div(v-for="(cli, clix) in d_rowModal.taskChecklist" id="'checkbox'+clix" :key="cli.order" class="main-checklist-item")
										b-button(class="btn-reorder-cl-item" variant="none" title="Reorder Checklist Item")
											fa-icon(icon="bars")
										<b-input-group-text >{{clix+1}}.</b-input-group-text>
										b-form-input(type="text" v-model="cli.desc" placeholder="Enter description of checklist item" title="Click to Edit")
										b-button(class="btn-remove remove-checklist" variant="none" v-b-tooltip:dragbox.hover.topleft.ds500="'Delete'" title="Remove Checklist Item" @click="m_removeCLItem(clix)")
											fa-icon(icon="trash-alt")
								b-button(class="btn-add btn-add-cl-item" variant="outline-primary" v-b-tooltip:dragbox.hover.topleft.ds500="'Add'" title="Add Checklist Item" @click="m_addCLItem")
									fa-icon(icon="plus") 
					</details>
</template>
<script type="text/javascript" src="jquery.min.js"></script>
<script>	
import {fn_processEvent,fn_getAppTenantSettings,fn_getRecord, fn_saveRecord, fn_getReminderOptions} from "@/utils/api.js";
import {fn_timeFmt,kbdpAlert, fn_AsyncGET,fn_recLbl, fn_taskParentLkp, fn_getUserOpts, fn_saveUserOpts, fn_isoDtStr, fn_profilePicURL} from "@/utils/util.js";
import {api_baseURL,refData, userInfo,userSettings, defaults, fn_appEnt} from "@/utils/ref-data.js";
import RecWrap from "@/components/RecWrap.vue";
import KTList from "@/components/Ctrl/KT-List.vue";
import {fn_getColumns} from "@/components/Ctrl/KT-Tasks.vue";
import {fn_validate} from "@/utils/appValidations.js";
import draggable from "vuedraggable";
import {VueEditor} from "vue2-editor";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import moment from "moment";


const const_rowModal = {
	id: null,
	//--> opportunityTaskId/projectTaskId/accountTaskId/calendarTaskId
	//--> opportunityId/projectId/accountId
	prntRec: null, //Object
	taskName: null,
	taskDescription: null,
	taskLeadId: null,
	taskLead: null, //Object
	taskAssignees: null, //Array of Objects
	externalContacts: null, //Array of Objects
	taskTypeId: null,
	taskStatusId: null,
	dueDate: null,
	completionDate: null,
	percentComplete: null,
	priority: null,
	taskChecklist: null, //Array of Objects (No Ids)
	taskDetails: null,
	calendarEventId: null,
	startDate: null,
	endDate: null,
	startTime: null,
	endTime: null,
	activityCost:null,

};
export default {
	inheritAttrs: false,
	name: "task-rec",
	components: {
		"rec-wrap": RecWrap,
		"kt-list": KTList,
		'kt-remind-opt': () => import("@/components/Ctrl/KT-ReminderOpt.vue"),
		draggable,
		VueEditor,
		PerfectScrollbar
	},
	created() {
		fn_getUserOpts(this.c_rec_Task, 'tsk').then(() => {
			fn_setFormOpts(this);
		});
		
		this.d_ktTable='kt-task-list-'+this.d_prntAppEnt.name+'Tasks';
		switch (this.p_prntRecKey) {
		case 'oppr': {
			if(this.p_taskId||this.p_taskData) this.d_taskId=this.p_taskId||this.p_taskData['opportunityTaskId'];
			break;
		}
		case 'proj': {
			if(this.p_taskId||this.p_taskData) this.d_taskId=this.p_taskId||this.p_taskData['projectTaskId'];
			break;
		}
		case 'acct': {
			if(this.p_taskId||this.p_taskData) this.d_taskId=this.p_taskId||this.p_taskData['accountTaskId'];
			break;
		}
		case 'cal': {
			if(this.p_taskId||this.p_taskData) this.d_taskId=this.p_taskId||this.p_taskData['calendarTaskId'];
			this.d_ktTable='kt-task-list-calendarTasks';
			break;
		}
	}
	
	console.log('In taskrec Created');
	console.log('this.d_ktTable:'+this.d_ktTable);
	console.log(this.d_prntAppEnt);
	console.log(this.c_rec_Task);


	},
	mounted() {
	
		var usrOpts = userSettings.userOptions;
		console.log('usrOpts');
		console.log(usrOpts);
		console.log('this.d_ktTable');
		console.log(this.d_ktTable);
		//this.d_readOnlyColumns=usrOpts['tableReadOnlyColumns'][this.d_ktTable]||[];
		//this.d_requiredColumns=usrOpts['tableRequiredColumns'][this.d_ktTable]||[];
		//this.d_requiredFields=this.d_requiredColumns.map(c=>{return c.field;});
		
		
		
	

		fn_aecTask(this);
		if(!this.d_rowModal.startTime) this.d_rowModal.startTime="09:00";
		if(!this.d_rowModal.endTime) this.d_rowModal.endTime="11:00";
		if(!this.d_rowModal.taskTypeId) this.d_rowModal.taskTypeId=this.d_ref.taskTypes.find(t=>t.name=='Onboarding').id;
		if(!this.d_rowModal.priority) this.d_rowModal.priority=this.d_ref.taskPriorities.find(t=>t.text.includes('Low')).value;

		//this.d_className=(this.d_ref.taskStatuses.find(t=>t.id==this.d_rowModal.taskStatusId).name).replace(' ');
		if(this.d_rowModal.taskStatusId)
			this.d_taskStatusId=this.d_rowModal.taskStatusId
		else {
				this.d_rowModal.taskStatusId=this.d_ref.taskStatuses.find(t=>t.name=='To Do').id;
				this.d_taskStatusId=this.d_ref.taskStatuses.find(t=>t.name=='To Do').id;
				}
				
		fn_getAppTenantSettings().then((resp) => {
			
				if (resp.error) {
					let msg = `Unable to read appTenantSetting Error: ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					} else {
							this.d_tenantSettings = resp.general || {};
							this.d_tenantName=resp.general.tenantName;
						}
		});

			
	
	},
	data() {
		return {
			d_ref: refData,
			d_prntAppEnt: fn_appEnt(this.p_prntRecKey),
			d_rowModal: {},
			d_cols: fn_getColumns(),
			d_loading: null,
			d_error: null,
			d_rmndOpt: [], //Keep empty array here
			d_ux: {cmpldt: false},
			d_teamMember: userInfo.getUserInfo().teamMember,
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
			//d_className:{},
			d_taskStatusId: null,
			d_taskComments:[],
			d_checkListIndex:null,
			d_selectedCheckList:[],
			d_validEndDate: null,
			d_validEndTime: null,
			d_endDateToolTip: null,
			d_endTimeToolTip: null,
			d_startDateToolTip:null,
			d_taskId:null,
			d_table:null,
			d_tenantName:null,
			d_raiseTaskEvent:null,
			d_ktTable:null,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_requiredFields:[],
		};
	},
	props: {
		p_mode: String,
		p_prntRecKey: String,//==> oppr, proj, acct, cal
		p_prntRecInfo: {type: Object, default: () => ({Id: null, No: null, Name: null, Team: []})},

		p_taskData: Object,
		p_refData: {type: Object, default: () => ({})},

		p_taskId: Number,

		p_paeChg: {type: Boolean, default: false}
	},
	computed: {
		c_tumpsUsers(){ return "Joseph Bolaji\nEnoque Panzo";},
		//c_validStartTime() { return this.m_validateTime(this.d_rowModal.startTime)},
		//c_validEndTime() { return this.m_validateTime(this.d_rowModal.endTime)},
		c_validStartDate(){return this.d_rowModal.startDate},
		c_startDateToolTip() {return this.d_startDateToolTip},
		c_validEndDate() {return this.d_validEndDate},
		c_endDateToolTip() {return this.d_endDateToolTip},
		c_validEndTime() {return this.d_validEndTime},
		c_endTimeToolTip() {return this.d_endTimeToolTip},
		c_checkListCount(){
			return this.d_rowModal.taskChecklist.length;
		},
		c_imgsrc(addedBy) {
				return api_baseURL+'/kbdp/profilePicture?tmid='+addedBy;
			},
		c_taskComments(){
			return this.d_taskComments;
		},
		c_completionClass(){
			var className;
			if(this.d_rowModal.taskStatusId)
				className=(this.d_ref.taskStatuses.find(t=>t.id==this.d_rowModal.taskStatusId).name).replace(' ','');
			return 'circleBox '+className;
		},
		c_completionStatus(){
			var completionStatus;
			if(this.d_rowModal.taskStatusId)
				completionStatus=(this.d_ref.taskStatuses.find(t=>t.id==this.d_rowModal.taskStatusId).name).padEnd(10);
			return completionStatus;
		},
		c_taskId(){ return this.p_prntRecInfo.Id; },
		c_rec_TaskId() {
			return this.d_prntAppEnt.name + "TaskId"; //=> opportunityTaskId | projectTaskId | accountTaskId
		},
		c_rec_Task() {
			return this.d_prntAppEnt.name + "Task"; //=> opportunityTask | projectTask | accountTask
		},
		c_rec_Activity() {
			return this.d_prntAppEnt.Name + " Activity";
		},
		c_prntIdKey() {
			return this.p_prntRecKey=='cal'?'CalendarTaskId':this.d_prntAppEnt.idKey;
		},
		c_appEnt() {
			return {
				key: 'task',
				// name: this.c_rec_Task,
				Name: 'Activity',
				// label: this.c_rec_Activity.slice(0, -1) + "ies",
				idKey: this.c_rec_TaskId
			};
		},
		c_hdrTitle() {
			if (this.c_isCal || this.p_paeChg) return null;

			let pri = this.p_prntRecInfo;
			if (pri.Id) return fn_recLbl(pri.No, pri.Name);

			let rm = this.d_rowModal;
			if (rm[this.c_rec_TaskId] && this.p_refData) {
				let prntId = rm[this.c_prntIdKey];
				let lkp = fn_taskParentLkp(prntId, this.p_refData, this.d_prntAppEnt);
				return fn_recLbl(lkp.prntNo, lkp.prntName);
			}
			return null;
		},
		c_isRecView() {
			return this.p_prntRecInfo.Id !== null;
		},
		c_isCal() {
			return this.d_prntAppEnt.key == 'cal';
		},
		c_paeOpts() {
			if (this.p_paeChg) {
				return ['cal', 'oppr', 'proj', 'acct'].map(key => {
					let lbl = fn_appEnt(key).Name + ' Activity';
					return {key, lbl};
				});
			}
			else return null;
		},
		c_localeStartTime(){return this.d_rowModal.startTime?fn_timeFmt(this.d_rowModal.startTime):null;},
		c_localeEndTime(){return this.d_rowModal.endTime?fn_timeFmt(this.d_rowModal.endTime):null;}
		},
	methods: {
		m_getQuill(editor){
			console.log("Editor Quill instance");
			console.log(editor);
			},
		//Modal Events
		m_tumpsUpClick(cix){ alert('tumpsUp:'+cix);},
		m_tumpsDownClick(cix){ alert('tumpsDown:'+cix);},
		m_validateEndDate(e){
				var startDate= new Date(this.d_rowModal.startDate);
				var endDate= new Date(e);
				var startEndDates={startDate: startDate, endDate: endDate};
				console.log('startEndDates');
				console.log(startEndDates);
				var endDateValidate=fn_validate('endDate', startEndDates);
				this.d_validEndDate=endDateValidate.valid;
				this.d_endDateToolTip="";
				if(!this.d_validEndDate){
							this.d_endDateToolTip=endDateValidate.errorMessage;
							kbdpAlert.showErr(endDateValidate.errorMessage);
                        } 	
		},
		m_validateEndTime(e){
				var startTime = new Date(this.d_rowModal.startDate+' '+this.d_rowModal.startTime);
				var endTime = new Date(this.d_rowModal.startDate+' '+e);
				var startEndTimes={startTime: startTime, endTime: endTime};
				console.log('startEndTimes');
				console.log(startEndTimes);
				var endTimeValidate=fn_validate('endTime', startEndTimes);
				this.d_validEndTime=endTimeValidate.valid;
				this.d_endTimeToolTip="";
				if(!this.d_validEndTime){
							this.d_endTimeToolTip=endTimeValidate.errorMessage;
							kbdpAlert.showErr(endTimeValidate.errorMessage);
                        }
		},		
		m_saveTask(e) {
			let rm = this.d_rowModal;
			console.log('d_rowModal');
			console.log(this.d_rowModal);
			if (this.p_prntRecInfo.Id) rm[this.c_prntIdKey] = this.p_prntRecInfo.Id;
		
		var startDate;
		var endDate;
		if(rm.startDate){startDate=new Date(rm.startDate+' '+rm.startTime);	
						endDate=new Date(rm.startDate+' '+rm.endTime); //Use same day
						}
		
		var taskLead={};
		var attendees=[];
		if(rm.taskLeadId)
			{taskLead.emailAddress=this.p_refData.teamMemberId.find(rec =>rec.teamMemberId==rm.taskLeadId).email;
			taskLead.name=this.p_refData.teamMemberId.find(rec =>rec.teamMemberId==rm.taskLeadId).teamMemberName;
			attendees.push({teamMemberId:rm.taskLeadId,emailAddress:{address:taskLead.emailAddress,name:taskLead.name}, type:'required'});
			}
		if(	rm.taskAssignees){
			if(rm.taskAssignees.length>0){
				var attendee={};
				var emailAddress={};
				rm.taskAssignees.forEach(a =>{
				var teamRec=this.p_refData.teamMemberId.find(rec =>rec.teamMemberId==a.teamMemberId);
				var name=teamRec.teamMemberName;
				var email=teamRec.email;
				var memberId=teamRec.teamMemberId;
				var attendee={teamMemberId:memberId,emailAddress:{address:email,name:name}, type:'required'};			
				attendees.push(attendee);
			})
			}
		}
			rm["taskStatus"]=this.d_ref.taskStatuses.filter(s=>s.id==rm.taskStatusId)[0].name;
			if(startDate) rm["startDateUTC"]=startDate.toISOString().slice(0, -2);
			if(endDate) rm["endDateUTC"]=endDate.toISOString().slice(0, -2);
			//if(rm.endDate) rm["endDate"]= new Date(rm["endDate"]+' '+rm.endTime).toISOString().slice(0, -2);
			if(taskLead) rm["taskLead"]=JSON.stringify(taskLead);
			if(attendees) rm["attendees"]=attendees;               //JSON.stringify(attendees);
			//rm["endDate"]= new Date(rm["endDate"]).toISOString().slice(0, -2);  //Calendar repeate frequency end date 
			let msg = fn_checkInvalid(this);
			if (msg) {
				e.preventDefault();
				kbdpAlert.showErr(msg);
				return;
			}
			else {
				kbdpAlert.clear();
			}

	
			let _this = this;
			//Add New comments
			var newComments=[]
			this.d_taskComments.forEach(c=>{
				if(c.new){
				var newComment={userComment:c.comment};
				newComments.push(newComment);
				}
			});
			

			
			rm["comments"]=newComments;
			
			//Add addedByName
			rm["addedByName"]=this.d_teamMember.teamMemberName;
			

			kbdpAlert.showSaving(_this.c_rec_Activity);
			fn_saveRecord(this.c_rec_Task, rm.id, rm).then(resp => {

				if (resp.error || !resp.upsRecHdr) {
					let msg = `Unable to save ${_this.c_rec_Activity}. ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					return;
				}
				let taskData = JSON.parse(JSON.stringify(rm));
				let upsRec = resp.upsRecHdr;
				var eventData=taskData;
				eventData["eventSource"]=this.p_prntRecKey;
				
				if (rm.id) {
					//Edited Existing
					taskData.updatedById = upsRec.updatedById;
					taskData.updatedUTC = upsRec.updatedUTC;
					eventData["eventSequence"]=new Date(upsRec.updatedUTC).getTime();
				} else {
					//Added New
					taskData[_this.c_rec_TaskId] = upsRec[_this.c_rec_TaskId];
					taskData.addedById = upsRec.addedById;
					taskData.addedUTC = upsRec.addedUTC;
					eventData["eventSequence"]=0;
					this.d_raiseTaskEvent=true;
				}
				
				_this.$emit('saved', taskData);
				kbdpAlert.showOk(this.c_rec_Activity + " was saved successfully.");
				eventData["eventUID"]=new Date(taskData.addedUTC).getTime();
				eventData["tenantName"]=this.d_tenantName;
				eventData["recordContext"]=this.c_prntIdKey; 
				eventData["recordId"]=this.p_prntRecKey=='cal'?'':rm.prntRec[this.c_prntIdKey];
				if(eventData.attendees&&eventData.startDateUTC&&eventData.endDateUTC&&this.d_raiseTaskEvent)
						fn_processEvent({eventName:'taskAssigned',eventData:eventData});
			});
		},
		m_close(e) {
			setTimeout(() => {this.$emit('closed');}, 50);
			kbdpAlert.clear();
		},
		//Checklist
		m_countCLItems(val) {
			if (!val || val.length == 0) return null;
			return val.filter(x => x.done).length + "/" + val.length;
		},
		m_addCLItem(e) {
			let tcl = this.d_rowModal.taskChecklist;
			let cli = {order: tcl.length + 1, done: false, desc: null};
			tcl.push(cli);

			setTimeout(() => {
				let cliElem = $(e.target)
					.closest(".ktt-cl")
					.find(".checklist-item")
					.last()
					.children("input:text");
				cliElem.focus();
			}, 100);
		},
		m_removeCLItem(clix) {
			console.log('In remove');
			this.d_rowModal.taskChecklist.splice(clix, 1);
			this.m_reorderCLItem();								
		},
		m_reorderCLItem() {
			this.d_rowModal.taskChecklist.forEach((cli, ix) => {
				cli.order = ix + 1;
				cli.done=false;
			});
		},
		m_createComments(){
		if(this.d_rowModal.comments){
		this.d_rowModal.comments.forEach((c,id)=>{
			let teamMemberName=c.teamMemberId==this.d_teamMemberId?'You':c.teamMemberName;
			this.d_taskComments.push({order:id,teamMemberName:teamMemberName, addedUTC: c.addedUTC.toISOString, 
			new:false,done:true,image: fn_profilePicURL(c.teamMemberId),comment:c.comment});
		});
		
		}
		},
		m_addComment(e){
			
			console.log('userInfo.getUserInfo');
			console.log( userInfo.getUserInfo().teamMember);
			console.log( userInfo.getUserInfo().teamMember.teamMemberId);
			let now=new Date();
			let cRow = {order: this.d_taskComments.length + 1, teamMemberId: this.d_teamMemberId,teamMemberName:'You', addedUTC:now, addedUTCString: now.toLocaleString(), new: true, 
						image: fn_profilePicURL(this.d_teamMemberId),comment: null};
			this.d_taskComments.unshift(cRow);
			setTimeout(() => {
				let commentElem = $(e.target)
					.closest(".ktt-comment")
					.find(".comment-item")
					.last()
					.children("input:text");
				commentElem.focus();
			}, 100);
			
			console.log('Comments after');
			console.log(this.d_taskComments);
			

			},
		m_removeComment(){
				//this.d_taskComments.splice(c,1);
		console.log('In removeComment');
		console.log(this.d_taskComments);
			if(this.d_taskComments[0].new)
				this.d_taskComments.splice(0,1);
		console.log('After removeComment');
		console.log(this.d_taskComments);
		},
		m_countComments(){
		return this.d_taskComments.length;
		},
		//Field Changes
		m_prntRecChange(ev) {
			let rm = this.d_rowModal;
			//let prntIdK = this.c_prntIdKey;
			let prntAE = this.d_prntAppEnt;
			let prntIdK = prntAE.idKey;
			rm.prntRec = ev;
			rm[prntIdK] = (ev || {})[prntIdK] || null;
			if (!rm[prntIdK]) return;
			fn_refDataPush(this, ev, prntIdK); //Need to fill local refData for Table View/Board View
		},
		m_tlChange(ev) {
			let rm = this.d_rowModal;
			rm.taskLead = ev;
			rm.taskLeadId = (ev || {}).teamMemberId || null;
			if (!rm.taskLeadId) return;

			fn_refDataPush(this, rm.taskLead, 'teamMemberId'); //Need to fill local refData for Table View/Board View
		},
		m_taChange(ev) {
			this.d_rowModal.taskAssignees = ev;
			if ((ev || []).length) fn_refDataPush(this, ev[0], 'teamMemberId'); //Need to fill local refData for Table View/Board View
		},
		m_ecChange(ev) {
			this.d_rowModal.externalContacts = ev;
			if ((ev || []).length) fn_refDataPush(this, ev[0], 'externalContactId'); //Need to fill local refData for Table View/Board View
		},
		m_tsChg(ev) {
			let isCmpl = refData.taskStatus(ev, null).name == 'Completed';
			let dux = this.d_ux;
			let rm = this.d_rowModal;

			if (isCmpl && !rm.completionDate) {
				rm.completionDate = fn_isoDtStr();
				dux.cmpldt = true;
			}
			else if (!isCmpl && dux.cmpldt) {
				rm.completionDate = null;
				dux.cmpldt = false;
			}
		},

		// Form Field Options
		m_formOptClick(col) {
			col.hideInForm = !col.hideInForm;

			let val = {};
			this.d_cols.filter(x => x.hideInForm !== undefined).forEach(x => {val[x.key] = x.hideInForm;});
			fn_saveUserOpts(this.c_rec_Task, 'taskFormFieldsHidden', val);
		},
		m_show(colKey) {
			return (this.d_cols.filter(x => x.key == colKey)[0] || {}).hideInForm !== true;
		},

		//Parent App Ent Change
		m_paeChg(opt) {
			this.d_prntAppEnt = fn_appEnt(opt.key);
		},
		m_timeFormatter(d){
								var today = new Date().toISOString().slice(0,10);
								var todayWithTime = new Date(today+'T'+d);
								return todayWithTime.toLocaleTimeString('en-US',{ hour: "2-digit", minute: "2-digit" });
							},
		m_validateTime(time){
	
				return moment(time.trim(),'hh:mm a', true).isValid()||
						moment(time.trim(),'HH:mm', true).isValid()||
						moment(time.trim(),'HH:mm:ss', true).isValid();
				},
				
		m_readOnly(col){ return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},
	},
	watch: {
		p_mode() {
			fn_aecTask(this);
		},
		d_taskStatusId(nv,ov){
			//this.d_className=(this.d_ref.taskStatuses.find(t=>t.id==nv).name).replace(' ','');
			this.d_rowModal.taskStatusId=nv;
			},
		d_rowModal(nv,ov){
			if(nv.startDate!=ov.startDate||
				nv.endDate!=ov.endDate||
				nv.taskLeadId!=ov.taskLeadId||
				nv.taskAssignees!=ov.taskAssignees
				) this.d_raiseTaskEvent=true;
		}
		
	}
};


function fn_aecTask(vc) {
	vc.d_rmPE = null;
	Object.keys(vc.d_ux).forEach(k => vc.d_ux[k] = false);
	kbdpAlert.clear();
	switch (vc.p_mode) {
		case 'add': {
			fn_addTask(vc);
			break;
		}
		case 'edit': {
			fn_getRmdOpts(vc);
			//if (vc.p_taskId) fn_getTaskData(vc)
			//else if (vc.p_taskData) fn_editTask(vc);
			fn_getTaskData(vc);
			//if (vc.p_taskData) fn_editTask(vc);
			fn_editTask(vc);
			break;
		}
		case 'clone': {
			fn_cloneTask(vc);
			break;
		}
		default: {
			vc.d_rowModal = {};
			this.d_rmndOpt = [];
			break;
		}
	}
}

//Add, Edit, Clone
function fn_addTask(vc) {
	let rm = vc.d_rowModal = {...const_rowModal};
	rm[vc.c_prntIdKey] = vc.p_prntRecInfo.Id;
	rm.taskStatusId = defaults.taskStatusId();
	rm.taskChecklist = [];

	let ptd = vc.p_taskData;
	if (ptd) {
		//...when adding from Task Board (Status, Lead, Activity Type, Priority)
		//...when adding from Calendar (Due Date)
		Object.keys(ptd).forEach(k => {rm[k] = ptd[k];});
		fn_taskLeadRefData(vc);
	}
	fn_taskParentRecord(vc);

	fn_showModal(vc);
}
function fn_editTask(vc, taskData, isClone) {
	let td = taskData || vc.p_taskData;
	if (!td) {
		fn_showModal(vc, true);
		return;
	}

	let rm = vc.d_rowModal = {...const_rowModal};

	rm[vc.c_prntIdKey] = td[vc.c_prntIdKey];


	Object.keys(rm).forEach(k => rm[k] = td[k] || null);
	if (!rm.taskChecklist) rm.taskChecklist = [];
	if (!isClone) {
		rm[vc.c_rec_TaskId] = rm.id = td[vc.c_rec_TaskId];
		let rmstr = JSON.stringify(rm);
		vc.d_rmPE = JSON.parse(rmstr); //Backup (Pre-Edit)
		vc.d_rowModal = JSON.parse(rmstr);
	}
	console.log('vc.d_rowModal');
	console.log(vc.d_rowModal);
	
	if(taskData){
	vc.d_taskStatusId=taskData.taskStatusId;
	vc.d_rowModal.taskStatusId=taskData.taskStatusId;
	}
	
	fn_taskParentRecord(vc);
	fn_taskLeadRefData(vc);
	fn_taskAssigneesRefData(vc);
	fn_externalContactsRefData(vc);

	fn_showModal(vc);
}
function fn_cloneTask(vc) {
	let td = vc.p_taskData;
	if (td) {
		td = JSON.parse(JSON.stringify(td));
		[vc.c_rec_TaskId, 'id', 'addedById', 'addedUTC', 'updatedById', 'updatedUTC'].forEach(k => td[k] = null);
	}
	fn_editTask(vc, td, true);
}



function fn_refDataPush(vc, rec, idK) {
	let rd = vc.p_refData;
	let exists;
	if (!rd[idK]) rd[idK] = [];
	else exists = rd[idK].filter(x => x[idK] == rec[idK])[0];
	if (!exists) rd[idK].push(rec);
}
function fn_taskParentRecord(vc) {
	if (vc.c_isCal) return;
	let rm = vc.d_rowModal;
	let prntAE = vc.d_prntAppEnt;
	let prntIdK = prntAE.idKey;
	if (vc.c_isRecView) {
		let prntRI = vc.p_prntRecInfo;
		rm.prntRec = {
			[prntIdK]: prntRI.Id,
			[prntAE.numKey]: prntRI.No,
			[prntAE.nameKey]: prntRI.Name,
		};
	}
	else if (rm[prntIdK]) {
		rm.prntRec = (vc.p_refData[prntIdK] || []).filter(x => x[prntIdK] == rm[prntIdK])[0];
	}
}
function fn_taskLeadRefData(vc) {
	let tlId = vc.d_rowModal.taskLeadId;
	if (!tlId) return;
	// let tl = vc.d_rowModal.taskLead;
	let rd = vc.p_refData.teamMemberId || [];
	vc.d_rowModal.taskLead = rd.filter(x => x.teamMemberId == tlId)[0];
}
function fn_taskAssigneesRefData(vc) {
	let tas = vc.d_rowModal.taskAssignees;
	if (!tas) return;
	let idk = 'teamMemberId';
	let rd = vc.p_refData[idk] || [];
	tas.forEach(ta => {
		let rdta = rd.filter(x => x[idk] == ta[idk])[0];
		if (!rdta) return;
		['teamMemberNo', 'teamMemberName', 'recDesc', 'profPic','email'].forEach(k => ta[k] = ta[k] || rdta[k]);
	});
}
function fn_externalContactsRefData(vc) {
	let ecs = vc.d_rowModal.externalContacts;
	if (!ecs) return;
	let idk = 'externalContactId';
	let rd = vc.p_refData[idk] || [];
	ecs.forEach(ec => {
		let rdec = rd.filter(x => x[idk] == ec[idk])[0];
		if (!rdec) return;
		['externalContactNo', 'externalContactName', 'recDesc','email'].forEach(k => ec[k] = ec[k] || rdec[k]);
	});
}


function fn_setFormOpts(vc) {
	let usrOpt = userSettings.userOptions['taskFormFieldsHidden'][vc.c_rec_Task];
	vc.d_cols.filter(x => x.hideInForm !== undefined).forEach(x => {
		let val = usrOpt[x.key];
		x.hideInForm = val === undefined ? x.hideInForm : val;
	});
}

function fn_checkInvalid(vc) {

	if (vc.p_mode == 'edit') {
		let noChg = fn_checkNoChange(vc);
		if (noChg) return 'No changes were made to the activity. Click "Close" to close the activity page.';
	}


	let bmKTTBody = $(vc.$refs["bm-kt-task"].$refs["body"]);
	let recTask = bmKTTBody.children('.rec-task');

	let invalid = [];
	let ist = recTask.find(':invalid').filter('input, select, textarea');
	let kts = recTask.find('.kt-select .input[invalid]');

	$.merge(ist, kts).closest('.form-group').children('label').each((i, e) => {invalid.push(e.textContent);});
	
	
	let customData=vc.d_rowModal['customData'];
	let fieldVal;
	let val;

	vc.d_requiredColumns.forEach(c=>{val=customData?vc.d_rowModal[c.field]||customData[c.field]:vc.d_rowModal[c.field];
									fieldVal=val instanceof Array?val[0]:val;
									if(!fieldVal&&!invalid.includes(c.title)) invalid.push(c.title);
									});

	if (invalid.length) {
		// ist.first().focus();
		return 'Please enter a valid value for the following field(s):\n"' + invalid.join('"\n"') + '"';
	}
	return null;
}
function fn_checkNoChange(vc) {
	let rmPE = vc.d_rmPE;
	if (!rmPE) return false;
	let rm = vc.d_rowModal;


	if((vc.d_taskComments.filter(c=>c.new)).length>0) return false;



	let rmpeK = Object.keys(rmPE).filter(k => !/(prntRec|taskLead$)/.test(k));
	let eqCnt = 0;

	rmpeK.every(k => {
		let valPE = rmPE[k];
		let val = rm[k];

		let isEq = false;
		if (valPE == null) {
			isEq = val == null;
		}
		else if (typeof (valPE) == 'object') {
			if (Array.isArray(valPE)) {
				if (k != 'taskChecklist') {
					let tmId = 'teamMemberId';
					let ecId = 'externalContactId';
					valPE = valPE.map(x => x[tmId] || x[ecId]);
					val = val.map(x => x[tmId] || x[ecId]);
				}
				// console.log(k, valPE, val);
				isEq = JSON.stringify(valPE) == JSON.stringify(val);
			}
			else {
				let idk = Object.keys(valPE)[0];
				isEq = valPE[idk] == val[idk];
			}
		}
		else {
			isEq = valPE == val;
		}

		if (isEq) {eqCnt++; return true;}
	});

	return rmpeK.length == eqCnt;
}

function fn_getTaskData(vc) {
	vc.d_loading = true;
	console.log('In fn_getTaskData');
	console.log(fn_getTaskData);
	fn_showModal(vc);
	fn_getRecord(vc.c_rec_Task, vc.d_taskId).then(resp => {
		if (resp.taskData) {
			console.log('taskData');
			console.log(resp.taskData);
			Object.keys(resp.refData || {}).forEach(k => {
				resp.refData[k].forEach(rec => fn_refDataPush(vc, rec, k));
			});
			

			
			if(resp.taskData.comments){	
			resp.taskData.comments.forEach((c,id)=>{
				let teamMemberName=c.teamMemberId==vc.d_teamMemberId?'You':c.teamMemberName;
				var taskComment={order:id,teamMemberId:c.teamMemberId, teamMemberName:teamMemberName, addedUTC: c.addedUTC,addedUTCString: new Date(c.addedUTC+'Z').toLocaleString(), 
				new:false,image: fn_profilePicURL(c.teamMemberId),addedById: c.addedById,comment:c.userComment};
				vc.d_taskComments.push(taskComment);
			});
			}

			fn_editTask(vc, resp.taskData);
		}
		else {
			fn_showModal(vc, true);
		}
		vc.d_loading = null;
	});
}

function fn_showModal(vc, err) {
	vc.d_error = !err ? null : 'Unable to load activity';
	vc.$bvModal.show("bm-kt-task");
}
///*
function fn_getRmdOpts(vc) {
	if (!vc.c_isCal) return; //only applies for calendar
	let ae = vc.c_appEnt;
	let context = ae.idKey;
	let contextId = vc.p_taskId || (vc.p_taskData || {})[ae.idKey];
	if (!contextId) return;
	fn_getReminderOptions(context, contextId).then(resp => {
		if (resp.reminderOptions) {
			vc.d_rmndOpt.length = 0;
			vc.d_rmndOpt.push(...resp.reminderOptions);
		}
	});
}
function fn_magnifyImg(x) {
   x.style.height = "64px";
   x.style.width = "64px";
}

function normalImg(x) {
   x.style.height = "32px";
   x.style.width = "32px";
}
function fn_tumpsUpClick(){ alert('tumpsUp');}

function fn_tumpsDownClick(){ alert('tumpsDown');}
//*/
</script>

<style lang="less">
#bm-kt-task {
	.modal-content {
		min-height: 500px;
		max-height: 90vh;
		padding: 0.3em;
		.modal-header {
			padding: 0.2em 0.5em;
			// justify-content: unset;
			> div:first-child {
				flex-grow: 1;
				> span {
					margin-right: 0.3em;
					&:nth-child(3) {
						font-size: 0.9em;
						&::before {
							content: "|";
							padding-right: 0.3em;
						}
					}
				}
				button.dropdown-toggle {
					font-size: 0.9em;
					line-height: 1em;
					padding-top: 0.1em;
					padding-bottom: 0.3em;
				}
			}

			> div:last-child {
				white-space: nowrap;
				margin-left: auto;
				button.dropdown-toggle {
					padding: 0.2em 0.3em;
					font-size: 0.9em;
					line-height: 1em;
					margin-left: 0.5em;
				}

				> div.opt-reminder {
					white-space: initial;
					> .btn .kt-bbl {
						background-color: #4fa4ff;
					}
				}
				> div.form-opts {
					ul.dropdown-menu {
						padding: 0.5em 0;
					}
					.dropdown-item {
						padding: 0.2em 1em;
						display: flex;
						input {
							margin: auto 0;
						}
						span {
							cursor: default;
							padding-left: 0.5em;
							font-size: 0.9em;
						}
					}
				}
			}
		}
		.modal-body {
			padding: 0.5em 1em;
			overflow-y: auto;
			border: solid 0.1em #dee2e6;

			> div.error {
				width: 100%;
				text-align: center;
			}
		}
		.modal-footer {
			justify-content: start;
			padding: 0.5em;
		}
	}

	div.form-group {
		min-width: 300px;
		display: flex;
		flex-wrap: wrap;
		> label {
			min-width: 130px;
			margin: auto 0;
		}

		> div,
		> input,
		> select,
		> textarea {
			min-width: 200px;
			flex-grow: 1;
			&:invalid {
				border-color: #dc3545;
			}
		}

		> textarea {
			min-height: 100px;
			max-width: calc(100% - 130px);
		}

		> .ktt-cl ktt-comment{
			> div:first-child {
				border: solid 0.1em #dee2e6;
				border-radius: 0.25em;
				padding: 0.2em 0.3em;
				overflow-y: auto;
				min-height: 100px;
				height: 100px;
				max-height: 400px;
				resize: vertical;
			}
			.checklist-item comment-item{
				position: relative;
				border-bottom: solid 0.1em #dee2e6;
				font-size: 0.9em;
				display: flex;
				input[type="checkbox"] {
					margin: auto 0;
					margin-right: 0.4em;
				}
				input[type="text"] {
					border: solid 0.1em #fff;
					border-radius: 0.15em;
					flex-grow: 1;
					padding-left: 4px;
					padding-right: 25px;
					&:focus {
						border-color: #adb5bd;
						background-color: #f8f9fa;
						outline: none;
					}
					&:hover {
						border-color: #ced4da;
					}
				}
				.btn-reorder-cl-item,
				.btn-remove-cl-item {
					opacity: 0.5;
					font-size: 0.8em;
					background-color: #e9ecef;
					box-shadow: unset;
					&:hover {
						opacity: unset;
					}
				}
				.btn-reorder-cl-item {
					right: 2.3em;
					cursor: move;
					margin: 0.2em 0;
					margin-right: 0.5em;
				}
				.btn-remove-cl-item {
					position: absolute;
					top: 50%;
					right: 0.4em;
					transform: translateY(-50%);
					padding: 0 0.3em;
				}
				&.sortable-chosen {
					// border-bottom: solid 0.2em #8fc4fd;
					// box-shadow: 0em 0.05em 0.1em 0.1em #8fc4fd;
					background-color: #e0f0ff;
					input[type="text"] {
						background-color: #e0f0ff;
					}
				}
			}
			.btn-add-cl-item, .btn-add-comment-item{
				font-size: 0.8em;
				line-height: 1em;
				padding: 0.2em 0.3em;
				svg {
					font-size: 0.9em;
				}
			}
		}

		&.fg-500 {
			flex-wrap: nowrap;
			> div,
			> input {
				max-width: 500px;
			}
		}
		@media (max-width: 476px) {
			&.fg-500 {
				flex-wrap: wrap;
				> div {
					min-width: 300px;
				}
			}
		}
		@media (max-width: 576px) {
			> .ktt-cl,
			> textarea {
				width: 100%;
				max-width: unset;
			}
		}
	}
	div.bm-kt-task-inline {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-bottom: 0.5em;
		div.form-group {
			margin-bottom: 0.3em;
			> input,
			> select {
				width: 150px;
				flex-grow: 0;
			}
		}
	}
/* Defining a custom border on all
            sides except the top side */
        .custom-field {
            border: 0.1em solid #dee2e6;
            border-top: none;
            margin: 5px 2px;   //32px 2px
            padding: 10px;
			border-radius: 25px;
        }
  
        /* Defining the style of the 
        heading/legend for custom fieldset */
        .custom-field h1 {
            font: 16px normal;
            margin: -16px -8px 0;
			opacity: 0.5;
        }
  
        /* Using float:left allows us to mimic
           the legend like fieldset. The 
           float:right property can also be 
           used to show the legend on right side */
  
        .custom-field h1 span {
            float: left;
        }
  
        /* Creating the custom top border to make
            it look like fieldset defining small 
            border before the legend. The width 
            can be modified to change position 
            of the legend */
        .custom-field h1:before {
            border-top: 0.1em solid #dee2e6;
            content: ' ';
            float: left;
            margin: 8px 2px 0 -1px;
            width: 12px;
			border-radius: 25px;
        }
  
        /* Defining a long border after the 
        legend, using overflow hidden to 
        actually hide the line behind the 
        legend text. It can be removed
        for a different effect */
        .custom-field h1:after {
            border-top: 0.1em solid #dee2e6;
            content: ' ';
            display: block;
            height: 24px;
            left: 2px;
            margin: 0 1px 0 0;
            overflow: hidden;
            position: relative;
            top: 8px;
			border-radius: 25px;
        }
.customMargin{
		margin: 0.1px 0.1px 0.1px 0.1px;
	}
.what{
	color:black !important;
	background-color:#2f5f98;
	}
.whatDetails{
	color: black !important;  //#31356e;   //black;   
	background-color: #87CEEB;   //#41b8d5; //#4076ba;
	}
.who{
	color: black !important;  //#31356e; //#2d8bba,#2f5f98,#31356e,#4076ba,#41b8d5,
	background-color: #2d8bba;  //#6495ED;        //#2f5f98;
	}
.when{
	color:black;
	}
.comments{
	color:#1E90FF;
	}
.checklist{
	color:#1E90FF;
	}
.ToDo{
	background-color:#FFCC00; //#FFDEAD;
	font-style: italic;
	color:black;
	}
.Canceled{
	background-color:tomato;
	font-style: italic;
	color:black;
	}
.OnHold{
	background-color:#CC5500;
	font-style: italic;
	color:black;
	}
.InProgress{
	background-color:#98FB98;
	font-style: italic;
	color:black;
	}
.Completed{
	background-color:#006400;
	font-style: italic;
	color:black;
	}
fieldset {
-webkit-border-radius: 8px;
-moz-border-radius: 8px;
border-radius: 8px;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.blueText{color: #1E90FF;
  }
.dateTime-parent-element { 
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-gap: 2px; 
    border: none; 
    width: 50%; 
} 
.dateTime-element { 
    margin: 1px; 
    border: none; 
}
.dateTime-parent{
		display:flex;
		}
.datePart { 
    flex: 1;
	float:left;
	width:52%;

}
.timePart {  
	width:48%; 
	float:right;
}	
.circleBox{
	padding:0x;
	border-radius: 100px;;
	-moz-border-radius:100px;
	-webkit-border-radius: 100px;
}
.noPadding {
   padding: 0 !important;
   margin: 0 !important;
   height:20px ! important;
}
.tab-title-class {
color: black !important;
  }
.small-round-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.commentBox {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #52687e;
  width: "100%";
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 50px;
  padding: 25px;
  background-color: lightgrey;
}
.scrollBar {
  height:150px;
  overflow-y: scroll;
}
.btn-remove {
		color: #dc3545; 
		}
.ktt-checklist{
				border: solid 0.1em #dee2e6;
				border-radius: 0.25em;
				padding: 0.2em 0.3em;
				overflow-y: auto;
				min-height: 100px;
				height: 100px;
				max-height: 400px;
				resize: vertical;
           }
.main-checklist-item {
				position: relative;
				border-bottom: solid 0.1em #dee2e6;
				font-size: 0.9em;
				display: flex;
				input[type="checkbox"] {
					margin: auto 0;
					margin-right: 0.4em;
				}
				input[type="text"] {
					border: solid 0.1em #fff;
					border-radius: 0.15em;
					flex-grow: 1;
					padding-left: 4px;
					padding-right: 25px;
					&:focus {
						border-color: #adb5bd;
						background-color: #f8f9fa;
						outline: none;
					}
					&:hover {
						border-color: #ced4da;
					}
				}
			}
.comment-item{
			border-bottom: solid 0.1em #dee2e6;
			//border-bottom: 1px solid #000;
	}
.btn-remove-checklist {
			opacity: 0.5;
			font-size: 0.8em;
			background-color: #e9ecef;
			box-shadow: unset;
			&:hover {
			opacity: unset;
					}
		}
.btn-add, .btn-remove {
		font-size: 0.85em;
		padding: 0.3em 0.2em;
		margin: 0 0.1em;
		border-radius: 0.2em;
		line-height: 1em;
		opacity: 0.5;
		border: none;
		width: 20px;
			}
.zoom {
  padding: 0px;
  background-color: green;
  transition: transform .2s;
  width: 5px;
  height:20px;
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.2); /* IE 9 */
  -webkit-transform: scale(1.2); /* Safari 3-8 */
  transform: scale(1.2); 
}
.tumpsBtn{
		font-size:10px;
		border:none;
}
}
</style>